export default {"src":"/_next/static/media/editor-link.73852ac1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};